import React, { useState, useEffect } from 'react';
import {
    ClientProspectingContainer,
    ClientProspectingContent,
    ClientProspectingHeader,
    ClientProspectingData
} from './styles';
import { descriptionConfirmation, descriptionSuccess } from './ModalDescriptions';
import { H4 } from '../../components/Typography/styles';
import colors from '../../assets/styles/colors';
import Loader from '../../components/Loader';
import Table from '../../components/Table';
import { prospectionStates, attachDocumentsStates } from '../../helpers/enum';
import ModalAction from '../../components/ModalAction';

import { IoIosAlert, IoIosCheckmarkCircle } from 'react-icons/io';

import { useLocation, useHistory } from 'react-router';

import { getCreditById } from '../../services/credit';
import { completeTask } from '../../services/documentsBpm';

const ClientProspecting = () => {

    const location = useLocation();
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [modalStep, setModalStep] = useState(1);
    
    const [credito, setCredito] = useState(null);
    const [data, setData] = useState(null);

    const headers = [
        {title: 'TIPO DE CONSULTA', size: 20},
        {title: 'ESTADO', size: 25},
        {title: 'DETALLES', size: 55}
    ];

    async function initializedStateComponent(){
        try{
            if (!location.idCredit) {
                return history.push('/admin/dashboard');
            }
            
            if(location.idCredit){
                let response = await getCreditById(location.idCredit);

                if(!response?.data){
                    return history.push('/admin/dashboard');
                }
                
                let creditoData = response.data;
                let estadoCredito = creditoData.estado;
                let estados = []
                estados = prospectionStates[estadoCredito];

                setCredito(creditoData);
                setData(estados);
                setIsLoading(false);
            }

        }catch(error){
            console.log(error);
            setIsLoading(false);
        }
    }

    const handleNavigate = (path) => {
        history.push(path);
    }

    const handleConfirm = async () => {
        let payload = {
            idCredit: credito?.id,
            idProcess: 5,
            taskName: "Gestión documentos Digicredito",
            genericVariables: []
        };

        try{
            setIsLoading(true);
            let response = await completeTask(payload);
            console.log(response);
            setModalStep(2);
            setIsLoading(false);
        }catch(e){
            console.log(e);
            setIsLoading(false);
        }
    }

    const handleDesist = async () => {
        let payload = {
            idCredit: credito?.id,
            idProcess: 5,
            taskName: "Gestión documentos Digicredito",
            genericVariables: [
                 {
                    name: "documentosCargados",
                    type: "Boolean",
                    value: false
                }
            ]
        };
        
        try{
            setIsLoading(true);
            let response = await completeTask(payload);
            console.log(response);
            handleNavigate('./dashboard');
            setIsLoading(false);
        }catch(e){
            console.log(e);
            setIsLoading(false);
            handleNavigate('./dashboard');
        }
    }

    useEffect(() => {
        initializedStateComponent();
    }, []);

    return (
        <ClientProspectingContainer>
            <ClientProspectingContent>
                <ClientProspectingHeader>
                    <H4 color={colors.textPrimary}>Prospección Cliente</H4>
                </ClientProspectingHeader>
                {isLoading && <Loader />}
                {
                    data &&
                    <ClientProspectingData>
                        <Table headers={headers} data={data} prospectingAttach={attachDocumentsStates.includes(credito.estado)} prospectingFunction={() => setShowModal(true)}/>
                    </ClientProspectingData>
                }
            </ClientProspectingContent>
            {showModal &&
                modalStep <= 1 ?
            <ModalAction
                open={showModal}
                title='Confirmación de gestión'
                description={descriptionConfirmation}
                setShowModal={setShowModal}
                actionLabelFunctionUpButton='Confirmar'
                actionLabelFunctionDownButton='Desistir'
                actionFunctionUpButton={() => handleConfirm()}
                actionFunctionDownButton={() => handleDesist()}
                bodyIcon={<IoIosAlert size={100} color={colors.bgDanger}/>}
            /> :
            <ModalAction
                open={showModal}
                title='!Muy bien!'
                description={descriptionSuccess}
                setShowModal={setShowModal}
                actionLabelFunctionUpButton='Continuar'
                actionLabelFunctionDownButton='Cerrar'
                actionFunctionUpButton={() => handleNavigate('./pendientes_adjuntar')}
                actionFunctionDownButton={() => {
                    setShowModal(false)
                }}
                bodyIcon={<IoIosCheckmarkCircle size={100} color={colors.bgSuccess}/>}
            />
            }
        </ClientProspectingContainer>    
    )
}

export default ClientProspecting;